import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData,
  type RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError,
  type RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse,
  removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete,
} from '../../generated';

export type RemoveUserFromOrganizationMutationVariables =
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData['path'];

export type RemoveUserFromOrganizationMutation =
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse;

export const useRemoveUserFromOrganizationMutation = <
  TError = RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      RemoveUserFromOrganizationMutation,
      TError,
      RemoveUserFromOrganizationMutationVariables,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<RemoveUserFromOrganizationMutation, TError, RemoveUserFromOrganizationMutationVariables, TContext>(
    {
      mutationKey: ['RemoveUserFromOrganization'],
      mutationFn: async ({ organization_id, user_id }: RemoveUserFromOrganizationMutationVariables) => {
        const { data } = await removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete({
          path: { organization_id, user_id },
          throwOnError: true,
        });
        return data;
      },
      ...options,
    },
  );
};

useRemoveUserFromOrganizationMutation.fetcher = (
  { organization_id, user_id }: RemoveUserFromOrganizationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete({
      path: { organization_id, user_id },
      throwOnError: true,
    });
    return data;
  };
};
